//Imports
import React from "react";
import Appbar from "../../components/appbar";
import ResponsiveAppBar from "../../components/appbar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import Footer from "../../components/footer";



//Function starts
export default function Internsettings(){

    //Custom Functions

    let navigate = useNavigate();

    const showupdatelog = () => {
        navigate("/intern/settings/updatelog")
    }



    return(
        <div>
            <ResponsiveAppBar/>
            <div>
                <Box className={"Appinfo"} sx={{width:800, height:300,  backgroundColor: "black", borderRadius: 3, position: 'absolute', left: '50%', top: '50%',
                    transform: 'translate(-50%, -50%)'}}>
                    <p className={"Appinfo-Headline"}>Familie Muscholl Web App</p>
                    <br/>
                    <p className={"Appinfo-Subheadline"}>Erste Veröffentlichung: 01.03.2022</p>
                    <br/>
                    <p className={"Appinfo-Subheadline"}>Letzes Update: 07.05.2023</p>
                    <br/>
                    <p className={"Appinfo-Subheadline"}>Version: 0.1.7</p>
                    <br/>
                    <Button  sx={{mx: 3, backgroundColor: "white", color: "black", "&:hover":{ backgroundColor: "#ba10d1"}}} variant="disabled" onClick={showupdatelog}>Update Log</Button>

                </Box>
            </div>
            <Footer/>
        </div>

    )
}